import { render, staticRenderFns } from "./ProjectAdMaterialEdit.vue?vue&type=template&id=61f0ee07"
import script from "./ProjectAdMaterialEdit.vue?vue&type=script&lang=js"
export * from "./ProjectAdMaterialEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports